import { useState, useEffect } from 'react';
import { axiosCandidatesApplication } from '../stateManagement/api';
import { ICandidateProfileApplicationResponse } from '../models/candidateProfile.model';
import { ICandidateApplication } from '../models/candidateProfile.model';

export const useCandidateApplication = ({
  candidateId,
  requisitionID,
}: ICandidateApplication) => {
  const [data, setData] = useState<
    ICandidateProfileApplicationResponse['applicationHistory']
  >([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        const response = await axiosCandidatesApplication(
          candidateId,
          requisitionID
        );
        setData(response.applicationHistory);
        setError(null);
      } catch (apiError: any) {
        setError(apiError.message);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  return { data, loading, error };
};
